<div class="w-[1100px] max-h-[760px] overflow-y-auto">
  <!-- Header -->
  <div class="flex items-center justify-between mb-4">
    <span class="text-[15px] font-bold text-[var(--base-text-dark)]" *ngIf="!isEditMode">CREATE NEW SEASON</span>
    <span class="text-[15px] font-bold text-[var(--base-text-dark)]" *ngIf="isEditMode">EDIT SEASON</span>
    <span class="material-icons cursor-pointer text-[var(--tertiary-text)] text-[20px] rounded-full w-7 h-7 flex items-center justify-center hover:bg-[var(--app-base)]"
      (click)="close()">close</span>
  </div>

  <!-- Step 1 -->
  <div class="flex items-center gap-3 mb-4">
    <div class="w-8 h-8 rounded-full bg-[var(--primary-dark)] text-white flex items-center justify-center text-[14px] font-bold shrink-0">1</div>
    <div class="flex flex-col">
      <span class="text-[14px] font-bold text-[var(--base-text-dark)]">STEP 1 <span class="font-normal">- Define Season</span></span>
      <span class="text-[11px] text-[var(--tertiary-text)]">Choose a start and end date and define the details for your season.</span>
    </div>
  </div>

  <form [formGroup]="createSeasonForm">
    <!-- Name + Dates -->
    <div class="flex items-start gap-3 mb-4 pl-11">
      <mat-form-field class="w-[220px]" appearance="outline">
        <mat-label>Season Name</mat-label>
        <input matInput formControlName="seasonDescription">
        <mat-error *ngIf="createSeasonForm.get('seasonDescription').invalid && createSeasonForm.get('seasonDescription').touched">
          *Required - Season Name
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-[170px]" appearance="outline">
        <mat-label>Start date</mat-label>
        <input matInput formControlName="filterStartDate" [max]="createSeasonForm.get('filterEndDate').value" [matDatepicker]="pickerStart" placeholder="Start" (dateInput)="setFilterStartDate($event)">
        <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="w-[170px]" appearance="outline">
        <mat-label>End date</mat-label>
        <input matInput formControlName="filterEndDate" [min]="createSeasonForm.get('filterStartDate').value" [matDatepicker]="pickerEnd" placeholder="End date" (dateInput)="setFilterEndDate($event)">
        <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Season Note -->
    <div class="pl-11 mb-5">
      <p class="text-[12px] font-semibold text-[var(--base-text-alt-dark)] mb-1.5">Season Note:</p>
      <textarea formControlName="seasonNote"
        class="w-full max-w-[600px] h-[120px] py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)] resize-none font-[Poppins]"></textarea>
    </div>

    <!-- Step 2 -->
    <div class="flex items-center gap-3 mb-4">
      <div class="w-8 h-8 rounded-full bg-[var(--primary-dark)] text-white flex items-center justify-center text-[14px] font-bold shrink-0">2</div>
      <div class="flex flex-col">
        <span class="text-[14px] font-bold text-[var(--base-text-dark)]">STEP 2 <span class="font-normal">- Allocate Fields</span></span>
        <span class="text-[11px] text-[var(--tertiary-text)]">Select the relevant fields you wish to include in the season.</span>
      </div>
    </div>

    <!-- Farm/Field Selection -->
    <div *ngIf="farmList.length > 0" class="pl-11 max-h-[280px] overflow-y-auto mb-4">
      <mat-accordion *ngFor="let farm of farmList; let farmIndex = index">
        <mat-expansion-panel class="!mb-2 !rounded-lg !shadow-[0_1px_4px_rgba(0,0,0,0.06)]">
          <mat-expansion-panel-header>
            <mat-panel-title class="!text-[14px] !font-medium !flex !items-center !gap-2">
              <mat-checkbox
                [indeterminate]="farm.isTouched"
                (change)="toggleAllFarmFieldsSelection($event, farmIndex)"
                (click)="$event.stopPropagation()"
                [checked]="farm.isChecked">
              </mat-checkbox>
              {{farm.name}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div *ngFor="let field of farm.fields; let fieldIndex = index"
            class="flex items-center gap-2 py-1.5 px-2 text-[12px]">
            <mat-checkbox
              (change)="onFieldSelectedChecked($event, fieldIndex, farmIndex)"
              [checked]="field.isChecked"
              [disabled]="field.isInAnotherActiveSeason">
            </mat-checkbox>
            <span class="font-semibold w-[80px]">Field Name:</span>
            <span class="w-[120px] truncate">{{field.name}}</span>
            <span class="font-semibold w-[90px]">Size HA:</span>
            <span class="w-[60px]">{{field.size | truncDecimals:2}}</span>
            <span class="font-semibold w-[110px]">In Active Season:</span>
            <span class="w-[40px]" [ngClass]="{'text-[var(--notification-success)]': field.isInAnotherActiveSeason, 'text-[var(--notification-error)]': !field.isInAnotherActiveSeason}">
              {{field.isInAnotherActiveSeason ? activeSeasonYES : activeSeasonNO}}
            </span>
            <span class="text-[var(--tertiary-text)] mx-1">|</span>
            <span class="truncate max-w-[100px]">{{field?.seasonName ?? placeholder}}</span>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div *ngIf="farmList.length === 0" class="pl-11 flex items-center justify-center h-[200px] text-[var(--tertiary-text)] text-[14px] font-medium">
      Please use date range to view relevant fields.
    </div>

    <!-- Step 3 -->
    <div class="flex items-center gap-3 mt-4">
      <div class="w-8 h-8 rounded-full bg-[var(--primary-dark)] text-white flex items-center justify-center text-[14px] font-bold shrink-0">3</div>
      <button *ngIf="!isEditMode" (click)="createNewSeason()"
        class="py-2 px-4 border-none rounded-lg text-xs font-semibold bg-[var(--primary-dark)] text-white cursor-pointer hover:opacity-90 transition-all">
        CREATE SEASON
      </button>
      <button *ngIf="isEditMode" (click)="updateSeason()"
        class="py-2 px-4 border-none rounded-lg text-xs font-semibold bg-[var(--primary-dark)] text-white cursor-pointer hover:opacity-90 transition-all">
        UPDATE
      </button>
      <div class="flex flex-col">
        <span class="text-[14px] font-bold text-[var(--base-text-dark)]">STEP 3 <span class="font-normal">- Create Season</span></span>
        <span class="text-[11px] text-[var(--tertiary-text)]">Allocate your selected farms/fields to a season.</span>
      </div>
    </div>
  </form>
</div>
